import React from 'react'
import classNames from 'classnames'
import './index.less'

export default ({ value, onChange, min, max, onBlur, maxLength = '25', className, ...props }) => {
  const _onChange = (e) => {
    let _value = e.target.value.replace(/\D/g, '')

    if (max) {
      _value = Math.min(_value, max)
    }
    if (min || min === 0) {
      _value = Math.max(_value, min)
    }
    if (!Number.isNaN(_value) || _value === '' || _value === '-') {
      onChange?.(_value)
    }
  }
  return <input value={value} onChange={_onChange} maxLength={maxLength} className={classNames('mn-input-number', className, { disabled: props.disabled })} {...props} />
}
